import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { selectDealershipSettings } from 'services/DealershipSettings/selectors';

const useCurrency = (currency?: string) => {
  const { locale } = useIntl();
  const dealershipSettings = useSelector(selectDealershipSettings());

  const dealershipCurrency = dealershipSettings.get('currency');
  const hookCurrency = currency ?? dealershipCurrency;

  const currencyFormat = useMemo(() => {
    return Intl.NumberFormat(
      locale,
      hookCurrency // Ensures a currency is provided, otherwise format a regular number.
        ? {
            style: 'currency',
            currency: hookCurrency,
          }
        : {}
    );
  }, [locale, hookCurrency]);

  return currencyFormat;
};

export default useCurrency;
